import { Injectable, OnDestroy } from '@angular/core';
import { MessageService } from './message.service';
import { LocalStorageService } from './localStorage.service';
import { PineLabPmtChannels, PineLabStorageEnum, PineLabsMergePopupEnum } from '../enums/pinelabs.enum';
import { Subject, Subscription } from 'rxjs';
import { TranslateService } from '@ngx-translate/core';
import { NzModalRef, NzModalService } from 'ng-zorro-antd/modal';
import { UtilService } from 'src/app/util/util.service';

@Injectable({
  providedIn: 'root',
})
export class PineLabService implements OnDestroy {

  translationText: any = {};
  isMergePopUpOpen:boolean = false;
  subscription = new Subscription();
  
  private excCartPlPmtProgressSubject = new Subject<any>();
  private excOrderRightPlPmtProgressSub = new Subject<any>();
  private excTableLayoutPlPmtProgressSub = new Subject<any>();

  excCartPlPmtProgress$ = this.excCartPlPmtProgressSubject.asObservable();
  excOrderRightPlPmtProgress$ = this.excOrderRightPlPmtProgressSub.asObservable();
  excTableLayoutPlPmtProgress$ = this.excTableLayoutPlPmtProgressSub.asObservable();

  constructor(
    private _messageService: MessageService,
    private _localStorage: LocalStorageService,
    private _translateService: TranslateService,
    private _modalService: NzModalService,
    private utilService: UtilService,
  ) {
    this._translateService.use(this._localStorage.get('language') || 'en_US');
    this.subscription.add(
      this._translateService.get(['APP']).subscribe((translation) => {
        this.translationText = translation.APP || {};
      })
    );
  }

  ngOnDestroy(): void {
    this.subscription.unsubscribe();
  }

  excCartPlPmtProgress() {
    this.excCartPlPmtProgressSubject.next();
  }
  excOrderRightPlPmtProgress(latestId) {
    this.excOrderRightPlPmtProgressSub.next(latestId);
  }

  excTableLayoutPlPmtProgress(latestId) {
    this.excTableLayoutPlPmtProgressSub.next(latestId);
  }

  isOrderIdInMergedArr(orderId,mergeArr):boolean{
    return mergeArr.some(item => item.orderid === orderId);
  }

  removePLDataByOrderId(orderId,mergedOrderArr=[],isSettleBillCall){
    let updatedData = this.getUpdatedPLData();
    let isRemoved = false;
    if(Array.isArray(updatedData)){
      updatedData = updatedData.filter(elm=>{
         if(elm.isMergedObj && this.isOrderIdInMergedArr(orderId,elm.mergedOrderArr)){
          isRemoved = true;
          return false;
         }else if(orderId === elm.orderId){
          isRemoved = true;
          return false;
         }else{
          return true;
         }
      });
      if(isRemoved){
        this.removePLTimer();
        this._localStorage.set(PineLabStorageEnum.PINE_LAB_STORAGE,JSON.stringify(updatedData));
        if(Array.isArray(mergedOrderArr) && mergedOrderArr.length){
          const latestId = this._localStorage.get(PineLabStorageEnum.PL_MERGE_ORDER_LATEST_SEL);
          this.excOrderRightPlPmtProgress(latestId);
          this.excTableLayoutPlPmtProgress(latestId);
        }
        if(isSettleBillCall){
          this.excCartPlPmtProgress();
        }
      }
    }
    return isRemoved;
  }

  getPLDataByOrderId(orderId){
    const updatedData = this.getUpdatedPLData();
    let order = {}
    if(Array.isArray(updatedData)){
      for(let i=0;i<updatedData.length;i++){
        if(updatedData[i].isMergedObj && this.isOrderIdInMergedArr(orderId,updatedData[i].mergedOrderArr)){
          order = {...updatedData[i]};
          break;
         }else if(orderId === updatedData[i].orderId){
          order = {...updatedData[i]};
         break
         }
      }
    }
    return order;
  }

  getUpdatedPLData(calledByStore=false){
    const plData = this._localStorage.get(PineLabStorageEnum.PINE_LAB_STORAGE);
    const currentTime = new Date().getTime();

    let updatedPLData = [];
    if(plData){
      updatedPLData = JSON.parse(plData);
      if(Array.isArray(updatedPLData)){
        updatedPLData =  updatedPLData.filter(elm => currentTime <= elm.deadlineTime);
       }
    }
   if(!calledByStore){
    this._localStorage.set(PineLabStorageEnum.PINE_LAB_STORAGE,JSON.stringify(updatedPLData));
   }
   return updatedPLData; 
  }

  getAmountForOrderToShow(orderId,plPmtInProcess){
    let amountToShow = plPmtInProcess['amount'];
    if(Array.isArray(plPmtInProcess['mergedOrderArr'])){
      const mergeArr = plPmtInProcess['mergedOrderArr'];
      if(plPmtInProcess['orderId']===orderId){
        mergeArr.forEach((elm)=>{
          amountToShow = amountToShow - elm.amount;
        });
      }else{
          for(let i=0;i<mergeArr.length;i++){
              if(mergeArr[i].orderid===orderId){
                amountToShow = mergeArr[i].amount;
                break;
              }
          }
      }
    }
   return amountToShow;
  }

  storePLData(data,mergedOrderArr,isSettleBillCall){
    const updatedData = this.getUpdatedPLData(true);
    this.startPLTimerForNotifier(data);
    if(Array.isArray(mergedOrderArr) && mergedOrderArr.length){
      updatedData.push({...data,isMergedObj:true,mergedOrderArr:mergedOrderArr});
    }else{
      updatedData.push({...data,isMergedObj:false,mergedOrderArr:[]});
    }
  
    this._localStorage.set(PineLabStorageEnum.PINE_LAB_STORAGE,JSON.stringify(updatedData));
    if(Array.isArray(mergedOrderArr) && mergedOrderArr.length){
      const latestId = this._localStorage.get(PineLabStorageEnum.PL_MERGE_ORDER_LATEST_SEL);
      this.excOrderRightPlPmtProgress(latestId);
      this.excTableLayoutPlPmtProgress(latestId);
    }
    if(isSettleBillCall){
      this.excCartPlPmtProgress();
    }
  }
  latestSelectedOrderLeft(id){
    this._localStorage.set(PineLabStorageEnum.PL_MERGE_ORDER_LATEST_SEL,id);
  }
  isPineLabEnabled(){
    // const restSettingsGlobal = (this.utilService.getRestaurantSettings() || {}).global || {};
    // return !!restSettingsGlobal.is_pine_lab_on || false;
    return true;
  }

  startPLTimerForNotifier(data): void { 
    if(data && data.startTime && data.deadlineTime){
      const startTime = data.startTime;
      const deadlineTime = data.deadlineTime;
      const totalTime = deadlineTime - startTime ;
      const plIntervalId = setInterval(() => {
        this._localStorage.set(PineLabStorageEnum.PL_INTERVAL_ID,plIntervalId);
        const currentTime = new Date().getTime() - startTime;
        if (currentTime >= totalTime) {
          const plIntervalIdLocal = this._localStorage.get(PineLabStorageEnum.PL_INTERVAL_ID);
          if(plIntervalIdLocal){
            this._messageService.showError(this.translationText?.TIME_EXPIRED_TEXT);
            clearInterval(plIntervalIdLocal);
           }
        }
      }, 1000); 
    }
  }
  removePLTimer(){
    const plIntervalIdLocal = this._localStorage.get(PineLabStorageEnum.PL_INTERVAL_ID);
    if(plIntervalIdLocal){
      clearInterval(plIntervalIdLocal);
      this._localStorage.remove(PineLabStorageEnum.PL_INTERVAL_ID);
     }
  }
  setMergePopUpOpen(val){
    this._localStorage.set(PineLabsMergePopupEnum.PL_IS_MERGE_OPEN,val);
  }
  checkIfMergePopUpOpen(){
     return this._localStorage.get(PineLabsMergePopupEnum.PL_IS_MERGE_OPEN) === PineLabsMergePopupEnum.PL_OPEN;
  }
  isPineLabPmtSuccess(data){
    if(PineLabPmtChannels.includes((data || {}).payment_channel_pusher)){
         this._messageService.showSuccess(this.translationText.PMT_SUCCESS_TEXT);
    }
  }

  async commonWaitingPaymentModal(params): Promise<NzModalRef<any>> {
    const { WaitingPaymentComponent } = await import(
      /* webpackPrefetch: true */ 'src/app/shared/components/waiting-payment/waiting-payment.component'
    );
    return this._modalService.create({
      nzContent: WaitingPaymentComponent,
      nzClosable: false,
      nzMaskClosable: false,
      nzBodyStyle: { width: 'auto', height: 'auto' },
      nzFooter: null,
      nzCentered: true,
      nzComponentParams: params,
    });
 }

  async commonPaymentStatusModal(pmtStatus, amount, paymentMethod): Promise<NzModalRef<any>> {
    const { PaymentStatusPopupComponent } = await import(
      /* webpackPrefetch: true */ 'src/app/shared/components/payment-status-popup/payment-status-popup.component'
    );
     return this._modalService.create({
      nzContent: PaymentStatusPopupComponent,
      nzClosable: false,
      nzMaskClosable: false,
      nzBodyStyle: { padding: '0' },
      nzFooter: null,
      nzWidth: '500px',
      nzCentered: true,
      nzComponentParams: {
        pmtStatus: pmtStatus,
        amount: amount,
        paymentMethod: paymentMethod,
        pmtSuccessText: this.translationText.PMT_SUCCESS_TEXT,
        pmtFailText: this.translationText.PMT_FAILED_TEXT
      },
    });
  }
  showPineLabsServiceUnavailableModal(): void {
    this._translateService
      .get([
        'SHARED.PINE_LABS_SERVICE_UNAVAILABLE_TITLE',
        'SHARED.PINE_LABS_SERVICE_UNAVAILABLE_MESSAGE',
      ])
      .subscribe((t) => {
        this._modalService.info({
          nzTitle: t['SHARED.PINE_LABS_SERVICE_UNAVAILABLE_TITLE'],
          nzContent: t['SHARED.PINE_LABS_SERVICE_UNAVAILABLE_MESSAGE'],
        });
      });
  }

  async commonTimeOutModal(amount): Promise<NzModalRef<any>> {
    const { TimeOutPopupComponent } = await import(
      /* webpackPrefetch: true */ 'src/app/shared/components/time-out-popup/time-out-popup.component'
    );
    return this._modalService.create({
      nzContent: TimeOutPopupComponent,
      nzClosable: false,
      nzMaskClosable: false,
      nzBodyStyle:  { padding: '0' } ,
      nzFooter: null,
      nzWidth: '45vw',
      nzComponentParams: {
       amount:amount,
      },
    });
 }
}
